import { withNamespace } from '../helper';

const namespace = '@CATEGORY';

export const SET_UPDATING_CATEGORY = withNamespace('SET_UPDATING_CATEGORY', namespace);

export const GET_CATEGORIES = withNamespace('GET_CATEGORIES', namespace);
export const GET_CATEGORIES_SUCCESS = withNamespace('GET_CATEGORIES_SUCCESS', namespace);

export const GET_CATEGORY_LIST = withNamespace('GET_CATEGORY_LIST', namespace);
export const GET_CATEGORY_LIST_SUCCESS = withNamespace('GET_CATEGORY_LIST_SUCCESS', namespace);

export const GET_DETAIL = withNamespace('GET_DETAIL', namespace);
export const GET_DETAIL_SUCCESS = withNamespace('GET_DETAIL_SUCCESS', namespace);

export const GET_REFERENCE_DATA_DETAIL = withNamespace('GET_REFERENCE_DATA_DETAIL', namespace);
export const GET_REFERENCE_DATA_DETAIL_SUCCESS = withNamespace(
  'GET_REFERENCE_DATA_DETAIL_SUCCESS',
  namespace,
);

export const GET_CATEGORY_FILE_SUB_TYPE = withNamespace('GET_CATEGORY_FILE_SUB_TYPE', namespace);
export const GET_CATEGORY_FILE_SUB_TYPE_SUCCESS = withNamespace(
  'GET_CATEGORY_FILE_SUB_TYPE_SUCCESS',
  namespace,
);

export const SUBMIT_DATA = withNamespace('SUBMIT_DATA', namespace);
export const SUBMIT_DATA_SUCCESS = withNamespace('SUBMIT_DATA_SUCCESS', namespace);

export const DELETE = withNamespace('DELETE', namespace);
export const DELETE_SUCCESS = withNamespace('DELETE_SUCCESS', namespace);

export const DEACTIVE = withNamespace('DEACTIVE', namespace);
export const DEACTIVE_SUCCESS = withNamespace('DEACTIVE_SUCCESS', namespace);

export const UPDATE = withNamespace('UPDATE', namespace);

export const SET_LOADING = withNamespace('SET_LOADING', namespace);
export const REQUEST_ERROR = withNamespace('REQUEST_ERROR', namespace);
